import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import MuiToggleButton from "@mui/material/ToggleButton";
import { testConnection, } from "../../services/purecloud";
import { styled } from "@mui/material/styles";

import {
  Alert,
  AlertColor,
  Backdrop,
  Chip,
  CircularProgress,
  Paper,
  Snackbar,
  TextField,
} from "@mui/material";
import { useState, useEffect, ReactNode, useRef } from "react";
import { v4 as uuidv4 } from "uuid";
import { DataGrid, GridActionsCellItem } from "@mui/x-data-grid";
import {
  getServerListService,
  getSSHPublicKey,
  saveServerDetails,
  getJobsByServer,
} from "../../services/purecloud";
import { getStorageItem } from "../../services/applicationStorage";
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from "@mui/material/DialogActions";
import {
  AuthenticationType,
} from "../../common/constants";
import moment from "moment";

interface ServerDetails {
  id: string;
  serverName: string;
  userName: string;
  password: string;
  port: string;
  authType: string;
  publicKey?: string;
}

const ToggleButton = styled(MuiToggleButton)({
  "&.Mui-selected, &.Mui-selected:hover": {
    color: "white",
    backgroundColor: "#1b2c48",
  },
  fontWeight: 700,
  color: "black",
  textAlign: "center",
});

const AddServer = () => {
  const serverDetailsRef = useRef<(string | ServerDetails)[]>([]);

  const [addServerDialogStaus, setaddServerDialogStaus] = useState<boolean>(false);
  const [isEditMode, setIsEditMode] = useState<boolean>(false);
  const [serverName, setServerName] = useState<string>("")
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [port, setPort] = useState<string>("");
  const [authType, setAuthType] = useState<string>(AuthenticationType.password);
  const [editingServerId, setEditingServerId] = useState<string | null>(null);
  const [originalPassword, setOriginalPassword] = useState<string>("");
  const [originalUserName, setOriginalUserName] = useState<string>("");

  const [rows, setRows] = useState<(string | ServerDetails)[]>([]);
  const [isFormDataLoading, setFormDataLoading] = useState<boolean>(false);
  const [getSnackDetails, setSnackDetails] = useState({
    open: false,
    message: (<></>) as ReactNode,
    severity: "success",
  });
  const [dialogAlert, setDialogAlert] = useState<{
    show: boolean;
    message: string;
    severity: AlertColor;
  }>({
    show: false,
    message: "",
    severity: "info",
  });
  const [deleteDialogState, setDeleteDialogState] = useState<{
    open: boolean;
    rowId: string | number | null;
    serverName: string;
  }>({
    open: false,
    rowId: null,
    serverName: "",
  });
  const [jobsUsingServer, setJobsUsingServer] = useState<{
    count: number;
    jobs: Array<{ jobId: string; automationName: string }>;
  }>({ count: 0, jobs: [] });
  const [isCheckingImpactedJobs, setIsCheckingImpactedJobs] = useState<boolean>(false);
  const [showJobsDialog, setShowJobsDialog] = useState<boolean>(false);
  const [editMetadata, setEditMetadata] = useState<{
    updatedByUserName?: string;
    updatedByUserId?: string;
    updatedOn?: number;
  } | null>(null);
  const [getPublicKeyDetails, setPublicKeyDetails] = useState<{
    publicKey: string;
    fingerprint: string;
  }>({ publicKey: "", fingerprint: "" });

  //This hooks is used to load initial data
  useEffect(() => {
    (async () => {
      try {
        setFormDataLoading(true);
        const [serverResponse, publicKeyResponse] = await Promise.allSettled([
          getServerListService(),
          getSSHPublicKey(),
        ]);

        if (serverResponse.status === "fulfilled") {
          serverDetailsRef.current = serverResponse.value.data.serverList;
          setRows(serverResponse.value.data.serverList || []);
        } else {
          throw serverResponse.reason;
        }

        if (publicKeyResponse.status === "fulfilled") {
          setPublicKeyDetails(publicKeyResponse.value.data || { publicKey: "", fingerprint: "" });
        }

        console.log("serverDetailsRef.current", serverDetailsRef.current);
      //   [
      //     {
      //         "password": "admin1",
      //         "secretName": "inno-sftp_43a8e287-d8ed-4a89-828e-244f1152f051_test_1772805868",
      //         "updatedByUserName": "Parthiban Thangarajan",
      //         "port": "42",
      //         "serverName": "ec2-52-207-224-39.compute-1.amazonaws.com",
      //         "id": "125571ae-9485-4f63-abab-f181cd52e8a8",
      //         "updatedByUserId": "dad95f86-eef4-4ae7-85b6-40a50fbbc290",
      //         "updatedOn": 1772805868,
      //         "userName": "admin",
      //         "authType": "password"
      //     },
      //     "ec2-54-84-79-251.compute-1.amazonaws.com"
      // ]
        setFormDataLoading(false);
      } catch (err) {
        console.error(err);
        setRows([]);
        setFormDataLoading(false);
        setSnackDetails({
          open: true,
          message: <>Please try again</>,
          severity: "error",
        });
      }
    })();
  }, []);

  /**
   * This method is called when the form is submitted
   * @param data form data
   */
  const validateServerForm = () => {
    const trimmedServerName = serverName.trim();
    const trimmedUserName = userName.trim();
    const trimmedPassword = password.trim();
    const trimmedPort = port.trim();

    if (authType === AuthenticationType.password || authType === AuthenticationType.sshandpassword) {
      if (!trimmedServerName || !trimmedUserName || !trimmedPassword) {
        setDialogAlert({
          show: true,
          message: "Please enter all required credentials (Server IP, Username, and Password)",
          severity: "error",
        });
        return false;
      }
    } else if (!trimmedServerName || !trimmedUserName) {
      setDialogAlert({
        show: true,
        message: "Please enter all required credentials (Server IP and Username)",
        severity: "error",
      });
      return false;
    }

    if (!trimmedPort) {
      setDialogAlert({
        show: true,
        message: "Please enter the port number",
        severity: "error",
      });
      return false;
    }

    setDialogAlert({ show: false, message: "", severity: "info" });
    return true;
  };

  const addServer = async () => {
    if (!validateServerForm()) {
      return;
    }

    const publicKey =
      authType === AuthenticationType.password ? "" : getPublicKeyDetails.publicKey;

    let newServerDetails = {
      id: uuidv4(),
      serverName: serverName,
      userName: userName,
      password: password,
      port: port,
      authType: authType,
      publicKey,
    }
    const configuration = {
      orgId: getStorageItem("organization-id", true, sessionStorage),
      serverList: [...serverDetailsRef.current, newServerDetails],
    };

    try {
      setFormDataLoading(true);
      await saveServerDetails(configuration);
      setSnackDetails({
        open: true,
        message: <>Server Details Updated Successfully</>,
        severity: "success",
      });
      serverDetailsRef.current = [...serverDetailsRef.current, newServerDetails];
      setRows([...rows, newServerDetails]);
      setaddServerDialogStaus(false);
      resetForm();
      setFormDataLoading(false);
    } catch (err) {
      console.log("setting form :", err);
      setFormDataLoading(false);
      setSnackDetails({
        open: true,
        message: <>Please try again</>,
        severity: "error",
      });
    }
  };

  /**
   * This method is called when updating an existing server
   */
  const updateServer = async () => {
    if (!validateServerForm()) {
      return;
    }

    const publicKey =
      authType === AuthenticationType.password ? "" : getPublicKeyDetails.publicKey;

    const updatedServerList = serverDetailsRef.current.map((server: any) => {
      if (typeof server === 'string') {
        return server === serverName ? {
          id: uuidv4(),
          serverName: serverName,
          userName: userName,
          password: password,
          port: port,
          authType: authType,
          publicKey,
        } : server;
      }
      return server.id === editingServerId ? {
        ...server,
        userName: userName,
        password: password,
        port: port,
        authType: authType,
        publicKey,
        updateSecret: password !== originalPassword || userName !== originalUserName,
      } : server;
    });

    const configuration = {
      orgId: getStorageItem("organization-id", true, sessionStorage),
      serverList: updatedServerList,
    };

    try {
      setFormDataLoading(true);
      await saveServerDetails(configuration);
      setSnackDetails({
        open: true,
        message: <>Server Details Updated Successfully</>,
        severity: "success",
      });
      serverDetailsRef.current = updatedServerList;
      setRows(updatedServerList);
      setaddServerDialogStaus(false);
      resetForm();
      setFormDataLoading(false);
    } catch (err) {
      console.log("updating server failed :", err);
      setFormDataLoading(false);
      setSnackDetails({
        open: true,
        message: <>Please try again</>,
        severity: "error",
      });
    }
  };

  /**
   * Reset form fields
   */
  const resetForm = () => {
    setServerName("");
    setUserName("");
    setPassword("");
    setPort("");
    setAuthType(AuthenticationType.password);
    setEditingServerId(null);
    setIsEditMode(false);
    setDialogAlert({ show: false, message: "", severity: "info" });
    setJobsUsingServer({ count: 0, jobs: [] });
    setIsCheckingImpactedJobs(false);
    setOriginalPassword("");
    setOriginalUserName("");
    setEditMetadata(null);
  };

  const fetchJobsUsingServer = async (targetServerName: string) => {
    setIsCheckingImpactedJobs(true);
    setJobsUsingServer({ count: 0, jobs: [] });
    try {
      const jobsResponse = await getJobsByServer(targetServerName);
      if (jobsResponse.success) {
        setJobsUsingServer({
          count: jobsResponse.data.count,
          jobs: jobsResponse.data.jobs || [],
        });
      }
    } catch (err) {
      console.error("Failed to fetch jobs for server:", err);
      setJobsUsingServer({ count: 0, jobs: [] });
    } finally {
      setIsCheckingImpactedJobs(false);
    }
  };

  /**
   * This method is used to delete server individual
   * @param serverName name of the server to be deleted
   * @returns void
   */
  const handleDeleteDialogOpen = (rowId: string | number, serverName: string) => () => {
    setDeleteDialogState({
      open: true,
      rowId,
      serverName,
    });
    void fetchJobsUsingServer(serverName);
  };

  const handleDeleteDialogClose = () => {
    setDeleteDialogState({
      open: false,
      rowId: null,
      serverName: "",
    });
  };

  const handleIndividualDelete = async () => {
    if (deleteDialogState.rowId === null) {
      return;
    }

    const { rowId, serverName } = deleteDialogState;
    handleDeleteDialogClose();

    const updatedServerList = serverDetailsRef.current.filter((v) =>
      typeof v === 'string' ? v !== serverName : v.id !== rowId
    );
    const configuration = {
      orgId: getStorageItem("organization-id", true, sessionStorage),
      serverList: updatedServerList,
    };
    try {
      setFormDataLoading(true);
      await saveServerDetails(configuration);
      setSnackDetails({
        open: true,
        message: <>Server Details Updated Successfully</>,
        severity: "success",
      });

      serverDetailsRef.current = updatedServerList;
      setRows(updatedServerList);
      setFormDataLoading(false);
    } catch (err) {
      console.log("handleIndividualDeleteClick failed :", err);
      setFormDataLoading(false);
      setSnackDetails({
        open: true,
        message: <>Please try again</>,
        severity: "error",
      });
    }
  };

  /**
   * This method is used to handle edit click
   * @param serverName name of the server to be edited
   */
  const handleEditClick = (rowId: string | number, serverName: string) => async () => {
    // Find the server details from the API response
    try {
      setFormDataLoading(true);
      const apiResponse = await getServerListService();
      const serverDetails = apiResponse.data.serverList.find((e: any) => {
        if (typeof e === 'string') return e === serverName;
        if (typeof e === 'object' && e !== null) return e.id === rowId;
        return false;
      });

      if (serverDetails) {
        if (typeof serverDetails === 'object') {
          setEditingServerId(serverDetails.id || null);
          setServerName(serverDetails.serverName || "");
          setUserName(serverDetails.userName || "");
          setPassword(serverDetails.password || "");
          setPort(serverDetails.port || "");
          setAuthType(serverDetails.authType || AuthenticationType.password);
          setOriginalPassword(serverDetails.password || "");
          setOriginalUserName(serverDetails.userName || "");
          setEditMetadata({
            updatedByUserName: serverDetails.updatedByUserName,
            updatedByUserId: serverDetails.updatedByUserId,
            updatedOn: serverDetails.updatedOn,
          });
        } else {
          setEditingServerId(null);
          setServerName(serverDetails);
          setUserName("");
          setPassword("");
          setPort("");
          setAuthType(AuthenticationType.password);
          setOriginalPassword("");
          setOriginalUserName("");
          setEditMetadata(null);
        }
        setIsEditMode(true);
        setaddServerDialogStaus(true);
        setFormDataLoading(false);
        void fetchJobsUsingServer(serverName);
        return;
      }
      setFormDataLoading(false);
    } catch (err) {
      console.error("handleEditClick failed:", err);
      setFormDataLoading(false);
      setSnackDetails({
        open: true,
        message: <>Failed to load server details</>,
        severity: "error",
      });
    }
  };

  const updateAuthType = (e: any) => {
    setAuthType(e.target.value)
  }

  const handlePublicKeyDownload = () => {
    if (!getPublicKeyDetails.publicKey) {
      setDialogAlert({
        show: true,
        message: "SSH public key is not available right now. Please try again.",
        severity: "error",
      });
      return;
    }

    const file = new Blob([getPublicKeyDetails.publicKey], {
      type: "text/plain",
    });

    const element = document.createElement("a");
    element.href = URL.createObjectURL(file);
    element.download = "publicKey.pub";
    element.click();
    URL.revokeObjectURL(element.href);
  };

  const testConnectionHandler = async () => {
    let body: any = {
      host: serverName,
      port: port,
      username: userName,
      type: authType,
    };

    if (authType === AuthenticationType.password || authType === AuthenticationType.sshandpassword) {
      body.password = password;
      if (!serverName || !userName || !password) {
        setDialogAlert({
          show: true,
          message: "Please enter all required credentials (Server IP, Username, and Password)",
          severity: "error",
        });
        return;
      }
    } else {
      if (!serverName || !userName) {
        setDialogAlert({
          show: true,
          message: "Please enter all required credentials (Server IP and Username)",
          severity: "error",
        });
        return;
      }
    }

    if (!port) {
      setDialogAlert({
        show: true,
        message: "Please enter the port number",
        severity: "error",
      });
      return;
    }

    setFormDataLoading(true);
    setDialogAlert({ 
      show: true, 
      message: "Please wait, testing connection...", 
      severity: "info" 
    });
    
    try {
      const sftpConnectionValidity = await testConnection(body);
      setDialogAlert({
        show: true,
        message: sftpConnectionValidity.message === "Connection successful!"
          ? "Test Connection is Successful"
          : "Invalid Credentials",
        severity: sftpConnectionValidity.message === "Connection successful!" ? "success" : "error",
      });
      setFormDataLoading(false);
    } catch (err: any) {
      console.log(err.message);
      setDialogAlert({
        show: true,
        message:   err.message || "Invalid Credentials or Connection Failed",
        severity: "error",
      });
      setFormDataLoading(false);
    }
  }

  const defaultWidthColumns = 50;
  const columns = [
    {
      field: "serverName",
      headerName: "Server Name",
      minWidth: defaultWidthColumns,
      flex: 1,
      renderCell: (params: any) => {
        const isOldFormat = !params.row.userName;
        
        return (
          <div style={{display: 'flex', flexDirection: 'column'}}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>{params.value}</span>
              {isOldFormat && <Chip label="Not configured" size="small" color="warning" />}
            </div>
              {!isOldFormat && 
              <span style={{fontWeight: '600', color: '#6c6c6cff'}}>
                User Name : {params.row.userName}</span>}
          </div>
        );
      },
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 180,
      cellClassName: "actions",
      getActions: ({ row: { id, serverName } }: any) => {
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            title="Edit"
            onClick={handleEditClick(id, serverName)}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            title="Delete"
            onClick={handleDeleteDialogOpen(id, serverName)}
            color="inherit"
          />,
        ];
      },
    },
  ];

  

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }} className="jobs-view">
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isFormDataLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
       

        <Dialog open={addServerDialogStaus} id="addServerDialog" PaperProps={{ sx: { borderRadius: "12px" } }}>
          <DialogTitle sx={{ pb: 0 }}>{isEditMode ? "Edit Server" : "Add New Server"}</DialogTitle>
          <DialogContent sx={{ pt: 1 }}>
            <DialogContentText component="div">
              <div style={{ width: "550px", display: "flex", flexDirection: "column", gap: "16px" }}>

                <span style={{ color: "#666", fontSize: "14px" }}>
                  {isEditMode ? "Update server details" : "Provide details to add new server"}
                </span>

                {isEditMode && editMetadata && (editMetadata.updatedByUserName || editMetadata.updatedOn) && (
                  <div style={{
                    fontSize: "12px",
                    color: "#888",
                    background: "#f5f5f5",
                    borderRadius: "6px",
                    padding: "8px 12px",
                    lineHeight: 1.7,
                  }}>
                    {editMetadata.updatedByUserName && (
                      <div>
                        <strong>Last Modified by</strong> : {editMetadata.updatedByUserName}
                        {editMetadata.updatedByUserId && (
                          <span> ({editMetadata.updatedByUserId})</span>
                        )}
                      </div>
                    )}
                    {editMetadata.updatedOn && (
                      <div>
                        <strong>Last Modified On</strong> : {moment.unix(editMetadata.updatedOn).format("MM/DD/YYYY, h:mm:ss a")} ({moment.unix(editMetadata.updatedOn).fromNow()})
                      </div>
                    )}
                  </div>
                )}

                {dialogAlert.show && (
                  <Alert 
                    severity={dialogAlert.severity} 
                    onClose={() => setDialogAlert({ show: false, message: "", severity: "info" })}
                  >
                    {dialogAlert.message}
                  </Alert>
                )}

                {isEditMode && isCheckingImpactedJobs && (
                  <Alert severity="info">
                    Checking impacted job...
                  </Alert>
                )}

                {isEditMode && !isCheckingImpactedJobs && jobsUsingServer.count > 0 && (
                  <Alert severity="info">
                    Server details used by {jobsUsingServer.count} job{jobsUsingServer.count > 1 ? 's' : ''}.
                    <Button 
                      size="small" 
                      onClick={() => setShowJobsDialog(true)}
                      sx={{ ml: 1, textTransform: 'none' }}
                    >
                      Know more
                    </Button>
                  </Alert>
                )}

                <TextField
                  variant="outlined"
                  size="small"
                  label="Server Name *"
                  value={serverName}
                  onChange={(e) => setServerName(e.target.value)}
                  disabled={isEditMode}
                  fullWidth
                />

                <TextField
                  variant="outlined"
                  size="small"
                  label="User Name *"
                  value={userName}
                  onChange={(e) => setUserName(e.target.value)}
                  fullWidth
                />

                <div>
                  <p style={{ margin: "0 0 8px 0", fontSize: "14px", fontWeight: 500 }}>Authentication Method</p>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <ToggleButtonGroup value={authType} size="small" exclusive onChange={updateAuthType}>
                      <ToggleButton value={AuthenticationType.password}>
                        Password
                      </ToggleButton>
                      <ToggleButton value={AuthenticationType.ssh}>
                        SSH Key
                      </ToggleButton>
                      <ToggleButton value={AuthenticationType.sshandpassword}>
                        SSH Key & Password
                      </ToggleButton>
                    </ToggleButtonGroup>

                    {authType != AuthenticationType.password && (
                      <Button
                        variant="contained"
                        sx={{ color: "white", backgroundColor: "#1b2c48" }}
                        onClick={handlePublicKeyDownload}
                      >
                        Download SSH
                      </Button>
                    )}
                  </div>
                </div>

                <div style={{ display: "flex", gap: "12px" }}>
                  <TextField
                    variant="outlined"
                    size="small"
                    type="password"
                    disabled={authType == AuthenticationType.ssh}
                    label="Password *"
                    sx={{ flex: 1 }}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <TextField
                    variant="outlined"
                    size="small"
                    label="Port *"
                    sx={{ width: "150px" }}
                    value={port}
                    onChange={(e) => setPort(e.target.value)}
                  />
                </div>

                {authType != AuthenticationType.password && (
                  <TextField
                    variant="outlined"
                    size="small"
                    label="Fingerprint"
                    fullWidth
                    disabled
                    value={getPublicKeyDetails.fingerprint}
                  />
                )}

                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "8px", paddingTop: "8px", borderTop: "1px solid #e0e0e0" }}>
                  <Button variant="contained" sx={{ color: "white", backgroundColor: "#1b2c48" }} onClick={testConnectionHandler} disabled={isFormDataLoading}>
                    Test Connection
                  </Button>
                  <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    {isFormDataLoading && <CircularProgress size={24} />}
                    <Button variant="contained" sx={{ color: "white", backgroundColor: "#1b2c48" }} onClick={() => isEditMode ? updateServer() : addServer()} disabled={isFormDataLoading}>
                      {isEditMode ? "Update" : "Save"}
                    </Button>
                    <Button variant="contained" onClick={() => {
                      setaddServerDialogStaus(false);
                      resetForm();
                    }} disabled={isFormDataLoading}>
                      Cancel
                    </Button>
                  </div>
                </div>

              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>

        <Dialog
          open={deleteDialogState.open}
          onClose={handleDeleteDialogClose}
          id="deleteServerConfirmDialog"
          PaperProps={{ sx: { borderRadius: "12px", minWidth: "380px" } }}
        >
          <DialogTitle>Delete Server</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to delete
              {deleteDialogState.serverName ? ` "${deleteDialogState.serverName}"` : " this server"}?
            </DialogContentText>
            <Alert severity={jobsUsingServer.count > 0 ? "warning" : "info"} sx={{ mt: 2 }}>
              {isCheckingImpactedJobs
                ? "Checking impacted job..."
                : jobsUsingServer.count > 0
                ? `Server details used by ${jobsUsingServer.count} job${jobsUsingServer.count > 1 ? "s" : ""}.`
                : "No jobs are currently using this server."}
              {!isCheckingImpactedJobs && jobsUsingServer.count > 0 && (
                <Button
                  size="small"
                  onClick={() => setShowJobsDialog(true)}
                  sx={{ ml: 1, textTransform: "none" }}
                >
                  Know more
                </Button>
              )}
            </Alert>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="outlined" onClick={handleDeleteDialogClose}>
              Cancel
            </Button>
            <Button
              variant="contained"
              color="error"
              onClick={handleIndividualDelete}
              disabled={isCheckingImpactedJobs || jobsUsingServer.count > 0}
            >
              Delete
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={showJobsDialog}
          onClose={() => setShowJobsDialog(false)}
          PaperProps={{ sx: { borderRadius: "12px", minWidth: "400px" } }}
        >
          <DialogTitle>Jobs Using This Server</DialogTitle>
          <DialogContent>
            <DialogContentText component="div">
              <ul style={{ paddingLeft: "20px", margin: "8px 0" }}>
                {jobsUsingServer.jobs.map((job) => (
                  <li key={job.jobId} style={{ marginBottom: "8px" }}>
                    {job.automationName}
                  </li>
                ))}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="contained" onClick={() => setShowJobsDialog(false)}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
        <div className="row">
          <div className=" ">
            <Button
              variant="contained"
              size="medium"
              sx={{
                color: "white",
                backgroundColor: "#1b2c48",
                marginBottom: "30px"
              }}
              type="submit"
              onClick={() => {
                resetForm();
                setaddServerDialogStaus(true);
              }}
            >
              Add
            </Button>
          </div>
        </div>

      <Box
        sx={{
          width: "100%",
          "& .actions": {
            color: "text.secondary",
          },
          "& .textPrimary": {
            color: "text.primary",
          },
        }}
      >
        <Backdrop
          sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={isFormDataLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <DataGrid
          rows={rows.map((server, index) => {
            if (typeof server === 'string') {
              return { id: index + 1, serverName: server };
            }
            return {
              id: server.id || index + 1,
              serverName: server.serverName,
              userName: server.userName,
              port: server.port,
              authType: server.authType,
            };
          })}
          columns={columns}
          initialState={{ pagination: { paginationModel: { pageSize: 5 } } }}
          pageSizeOptions={[5, 10, 25, 50, 100]}
        />
      </Box>
      {getSnackDetails.open && (
        <Snackbar
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          open={getSnackDetails.open}
          autoHideDuration={5000}
          onClose={(_event, reason?: string) => {
            if (reason === "clickaway") {
              return;
            }
            setSnackDetails({ open: false, message: <></>, severity: "error" });
          }}
        >
          <Alert
            severity={getSnackDetails.severity as AlertColor}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {getSnackDetails.message as ReactNode}
          </Alert>
        </Snackbar>
      )}
    </Paper>
  );
};

export default AddServer;
